var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3335 52H24.3335L12.3335 64V52H0.333496V0H56.3335V52Z",
    fill: "#D8D1C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 30.8333L24.6192 29H32.0478L41.3335 30.8333V40H15.3335V30.8333Z",
    fill: "#004048"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8335,
    cy: 19.5,
    r: 7.5,
    fill: "#004048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3b3e82c6ae722840f5990e7a16c00a91.svg";
export { ForwardRef as ReactComponent };